import { TranslationSet } from '../types';

export const common: TranslationSet = {
  'common.appName': {
    en: 'Baby Diary',
    ja: 'ベビーダイアリー',
    es: 'Diario del Bebé',
    zh: '婴儿日记',
    fa: 'دفترچه یادداشت کودک'
  },
  'common.loading': {
    en: 'Loading...',
    ja: '読み込み中...',
    es: 'Cargando...',
    zh: '加载中...',
    fa: 'در حال بارگذاری...'
  },
  'common.error': {
    en: 'Error',
    ja: 'エラー',
    es: 'Error',
    zh: '错误',
    fa: 'خطا'
  },
  'common.success': {
    en: 'Success',
    ja: '成功',
    es: 'Éxito',
    zh: '成功',
    fa: 'موفقیت'
  },
  'common.cancel': {
    en: 'Cancel',
    ja: 'キャンセル',
    es: 'Cancelar',
    zh: '取消',
    fa: 'لغو'
  },
  'common.save': {
    en: 'Save',
    ja: '保存',
    es: 'Guardar',
    zh: '保存',
    fa: 'ذخیره'
  },
  'common.delete': {
    en: 'Delete',
    ja: '削除',
    es: 'Eliminar',
    zh: '删除',
    fa: 'حذف'
  },
  'common.edit': {
    en: 'Edit',
    ja: '編集',
    es: 'Editar',
    zh: '编辑',
    fa: 'ویرایش'
  },
  'common.view': {
    en: 'View',
    ja: '表示',
    es: 'Ver',
    zh: '查看',
    fa: 'مشاهده'
  },
  'common.add': {
    en: 'Add',
    ja: '追加',
    es: 'Agregar',
    zh: '添加',
    fa: 'افزودن'
  },
  'common.remove': {
    en: 'Remove',
    ja: '削除',
    es: 'Quitar',
    zh: '移除',
    fa: 'حذف'
  },
  'common.submit': {
    en: 'Submit',
    ja: '送信',
    es: 'Enviar',
    zh: '提交',
    fa: 'ارسال'
  },
  'common.close': {
    en: 'Close',
    ja: '閉じる',
    es: 'Cerrar',
    zh: '关闭',
    fa: 'بستن'
  },
  'common.search': {
    en: 'Search',
    ja: '検索',
    es: 'Buscar',
    zh: '搜索',
    fa: 'جستجو'
  },
  'common.filter': {
    en: 'Filter',
    ja: 'フィルター',
    es: 'Filtrar',
    zh: '筛选',
    fa: 'فیلتر'
  },
  'common.sort': {
    en: 'Sort',
    ja: '並べ替え',
    es: 'Ordenar',
    zh: '排序',
    fa: 'مرتب سازی'
  },
  'common.share': {
    en: 'Share',
    ja: '共有',
    es: 'Compartir',
    zh: '分享',
    fa: 'اشتراک گذاری'
  },
  'common.back': {
    en: 'Back',
    ja: '戻る',
    es: 'Atrás',
    zh: '返回',
    fa: 'بازگشت'
  },
  'common.next': {
    en: 'Next',
    ja: '次へ',
    es: 'Siguiente',
    zh: '下一步',
    fa: 'بعدی'
  },
  'common.previous': {
    en: 'Previous',
    ja: '前へ',
    es: 'Anterior',
    zh: '上一步',
    fa: 'قبلی'
  },
  'common.continue': {
    en: 'Continue',
    ja: '続ける',
    es: 'Continuar',
    zh: '继续',
    fa: 'ادامه'
  },
  'common.create': {
    en: 'Create',
    ja: '作成',
    es: 'Crear',
    zh: '创建',
    fa: 'ایجاد'
  },
  'common.update': {
    en: 'Update',
    ja: '更新',
    es: 'Actualizar',
    zh: '更新',
    fa: 'به روز رسانی'
  },
  'common.upload': {
    en: 'Upload',
    ja: 'アップロード',
    es: 'Subir',
    zh: '上传',
    fa: 'بارگذاری'
  },
  'common.download': {
    en: 'Download',
    ja: 'ダウンロード',
    es: 'Descargar',
    zh: '下载',
    fa: 'دانلود'
  },
  'common.yes': {
    en: 'Yes',
    ja: 'はい',
    es: 'Sí',
    zh: '是',
    fa: 'بله'
  },
  'common.no': {
    en: 'No',
    ja: 'いいえ',
    es: 'No',
    zh: '否',
    fa: 'خیر'
  },
  'common.ok': {
    en: 'OK',
    ja: 'OK',
    es: 'OK',
    zh: 'OK',
    fa: 'بله'
  },
  'common.confirm': {
    en: 'Confirm',
    ja: '確認',
    es: 'Confirmar',
    zh: '确认',
    fa: 'تایید'
  },
  'common.select': {
    en: 'Select',
    ja: '選択',
    es: 'Seleccionar',
    zh: '选择',
    fa: 'انتخاب'
  },
  'common.today': {
    en: 'Today',
    ja: '今日',
    es: 'Hoy',
    zh: '今天',
    fa: 'امروز'
  },
  'common.yesterday': {
    en: 'Yesterday',
    ja: '昨日',
    es: 'Ayer',
    zh: '昨天',
    fa: 'دیروز'
  },
  'common.day': {
    en: 'Day',
    ja: '日',
    es: 'Día',
    zh: '天',
    fa: 'روز'
  },
  'common.week': {
    en: 'Week',
    ja: '週',
    es: 'Semana',
    zh: '周',
    fa: 'هفته'
  },
  'common.month': {
    en: 'Month',
    ja: '月',
    es: 'Mes',
    zh: '月',
    fa: 'ماه'
  },
  'common.year': {
    en: 'Year',
    ja: '年',
    es: 'Año',
    zh: '年',
    fa: 'سال'
  },
  'common.date': {
    en: 'Date',
    ja: '日付',
    es: 'Fecha',
    zh: '日期',
    fa: 'تاریخ'
  },
  'common.time': {
    en: 'Time',
    ja: '時間',
    es: 'Hora',
    zh: '时间',
    fa: 'زمان'
  },
  'common.dateTime': {
    en: 'Date & Time',
    ja: '��時',
    es: 'Fecha y hora',
    zh: '日期和时间',
    fa: 'تاریخ و زمان'
  },
  'common.name': {
    en: 'Name',
    ja: '名前',
    es: 'Nombre',
    zh: '名称',
    fa: 'نام'
  },
  'common.email': {
    en: 'Email',
    ja: 'メールアドレス',
    es: 'Correo electrónico',
    zh: '电子邮件',
    fa: 'ایمیل'
  },
  'common.password': {
    en: 'Password',
    ja: 'パスワード',
    es: 'Contraseña',
    zh: '密码',
    fa: 'رمز عبور'
  },
  'common.phone': {
    en: 'Phone',
    ja: '電話番号',
    es: 'Teléfono',
    zh: '电话',
    fa: 'تلفن'
  },
  'common.address': {
    en: 'Address',
    ja: '住所',
    es: 'Dirección',
    zh: '地址',
    fa: 'آدرس'
  },
  'common.city': {
    en: 'City',
    ja: '市区町村',
    es: 'Ciudad',
    zh: '城市',
    fa: 'شهر'
  },
  'common.state': {
    en: 'State',
    ja: '都道府県',
    es: 'Estado',
    zh: '州/省',
    fa: 'استان'
  },
  'common.zip': {
    en: 'ZIP Code',
    ja: '郵便番号',
    es: 'Código postal',
    zh: '邮政编码',
    fa: 'کد پستی'
  },
  'common.country': {
    en: 'Country',
    ja: '国',
    es: 'País',
    zh: '国家',
    fa: 'کشور'
  },
  'common.welcome': {
    en: 'Welcome',
    ja: 'ようこそ',
    es: 'Bienvenido',
    zh: '欢迎',
    fa: 'خوش آمدید'
  },
  'common.logout': {
    en: 'Logout',
    ja: 'ログアウト',
    es: 'Cerrar sesión',
    zh: '登出',
    fa: 'خروج'
  },
  'common.login': {
    en: 'Login',
    ja: 'ログイン',
    es: 'Iniciar sesión',
    zh: '登录',
    fa: 'ورود'
  },
  'common.signup': {
    en: 'Sign Up',
    ja: '登録',
    es: 'Registrarse',
    zh: '注册',
    fa: 'ثبت نام'
  },
  'common.forgotPassword': {
    en: 'Forgot Password',
    ja: 'パスワードを忘れた',
    es: 'Olvidé mi contraseña',
    zh: '忘记密码',
    fa: 'رمز عبور را فراموش کرده‌اید'
  },
  'common.resetPassword': {
    en: 'Reset Password',
    ja: 'パスワードをリセット',
    es: 'Restablecer contraseña',
    zh: '重置密码',
    fa: 'رمز عبور را بازنشانی کنید'
  },
  'common.pleaseWait': {
    en: 'Please wait...',
    ja: 'お待ちください...',
    es: 'Por favor espere...',
    zh: '请稍等...',
    fa: 'لطفاً منتظر بمانید...'
  },
  'common.required': {
    en: 'Required',
    ja: '必須',
    es: 'Requerido',
    zh: '必填',
    fa: 'پرداختی الزامی است'
  },
  'common.optional': {
    en: 'Optional',
    ja: '任意',
    es: 'Opcional',
    zh: '可选',
    fa: 'اختیاری است'
  },
  'common.description': {
    en: 'Description',
    ja: '説明',
    es: 'Descripción',
    zh: '描述',
    fa: 'توضیحات'
  },
  'common.title': {
    en: 'Title',
    ja: 'タイトル',
    es: 'Título',
    zh: '标题',
    fa: 'عنوان'
  },
  'common.message': {
    en: 'Message',
    ja: 'メッセージ',
    es: 'Mensaje',
    zh: '消息',
    fa: 'پیام'
  },
  'common.note': {
    en: 'Note',
    ja: '注意',
    es: 'Nota',
    zh: '备注',
    fa: 'یادداشت'
  },
  'common.translating': {
    en: 'Translating...',
    ja: '翻訳中...',
    es: 'Traduciendo...',
    zh: '翻译中...',
    fa: 'در حال ترجمه...'
  },
  'common.home': {
    en: 'Home',
    ja: 'ホーム',
    es: 'Inicio',
    zh: '首页',
    fa: 'خانه'
  },
  'common.generate': {
    en: 'Generate',
    ja: '作成',
    es: 'Generar',
    zh: '生成',
    fa: 'تولید'
  },
  'common.entries': {
    en: 'Entries',
    ja: '記録',
    es: 'Entradas',
    zh: '条目',
    fa: 'ورودی‌ها'
  },
  'common.statistics': {
    en: 'Statistics',
    ja: '統計',
    es: 'Estadísticas',
    zh: '统计',
    fa: 'آمار'
  },
  'common.gallery': {
    en: 'Gallery',
    ja: 'ギャラリー',
    es: 'Galería',
    zh: '画廊',
    fa: 'گالری'
  },
  'common.premium': {
    en: 'Premium',
    ja: 'プレミアム',
    es: 'Premium',
    zh: '高级版',
    fa: 'حساب ویژه'
  }
};
